import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { BaseFieldRenderer } from '../../../core/runtime/base/base-field-renderer';

@Component({
  selector: 'app-money-renderer',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './money-renderer.component.html'
})
export class MoneyRendererComponent
extends BaseFieldRenderer {

  get decimalScale(): number {

    return this.field.decimal?.scale ?? 2;
  }
}